import { render } from "./add-icon.vue?vue&type=template&id=bf39dce0"
import script from "./add-icon.vue?vue&type=script&lang=js"
export * from "./add-icon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__